// src/features/game/components/GameFilterBar.tsx

import React from 'react';

import {
  Search,
} from 'lucide-react';

import type {
  GameFilterType,
} from '../hooks/useGames';

interface GameFilterBarProps {
  filter: GameFilterType;

  onFilterChange: (
    filter: GameFilterType,
  ) => void;

  searchTerm: string;

  onSearchChange: (
    value: string,
  ) => void;
}

const FILTERS: {
  value: GameFilterType;
  label: string;
}[] = [
  {
    value: 'all',
    label: '전체 게임',
  },
  {
    value: 'running',
    label: '진행 중',
  },
  {
    value: 'waiting',
    label: '대기 중',
  },
  {
    value: 'finished',
    label: '종료됨',
  },
];

const GameFilterBar:
  React.FC<
    GameFilterBarProps
  > = ({
    filter,
    onFilterChange,
    searchTerm,
    onSearchChange,
  }) => {
  return (
    <div className="flex flex-col gap-4 lg:flex-row lg:items-center lg:justify-between">
      <div className="flex flex-wrap gap-2">
        {FILTERS.map(
          (item) => (
            <button
              key={
                item.value
              }
              type="button"
              onClick={() =>
                onFilterChange(
                  item.value,
                )
              }
              className={`rounded-lg px-4 py-2 text-16-medium ${
                filter ===
                item.value
                  ? 'bg-black text-white'
                  : 'bg-gray-200 text-gray-700 hover:bg-gray-300'
              }`}
            >
              {
                item.label
              }
            </button>
          ),
        )}
      </div>

      <div className="relative w-full lg:w-64">
        <Search
          size={20}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"
        />

        <input
          type="search"
          value={
            searchTerm
          }
          onChange={(event) =>
            onSearchChange(
              event.target.value,
            )
          }
          placeholder="게임 검색..."
          className="w-full rounded-lg border border-gray-300 py-2 pl-10 pr-4 outline-none focus:border-main"
        />
      </div>
    </div>
  );
};

export default GameFilterBar;